/*
* @Author: Jens K
* @Date:   2017-12-19 13:52:06
* @Last Modified by:   Jens K
* @Last Modified time: 2018-01-04 11:44:25
*/
var $ = require('jquery');
var Flickity = require('flickity');
var jQueryBridget = require('jquery-bridget');

var windowWidth = $(window).width(),
    medium = 640,
    large = 1024,
    showButtons = false,
    showDots = false,
    isDraggable = false;

jQueryBridget( 'flickity', Flickity, $ );

function categorySlider(){

    if (windowWidth < large) {

        showDots = true;
        isDraggable = true;

    }

    $('.categories--carousel--slider').flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: showButtons,
        draggable: isDraggable,
        groupCells: 2,
        pageDots: showDots
    });

}

function articleSlider(){

    if (windowWidth < large) {

        showDots = true;
        isDraggable = true;

    }

    $('.latest--articles--slider').flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: showButtons,
        draggable: isDraggable,
        pageDots: showDots
    });

}

categorySlider();
articleSlider();
